<template>
    <div class="row mb-8">
        <div class="col d-flex justify-content-start">
            <span class="title">{{ $t('Brands.Add') }}</span>
        </div>
        <div class="col d-flex gap-2 justify-content-end">
            <genericBtnComponent :disabled="loader" :ClickFun="validateBrand" svg="1" :Title="$t('purchaseOrder.save')"
                :loader="loader" />
        </div>

    </div>
    <v-card elevation="0">
        <div class="row ma-4">
            <div class="col-4 justify-content-start">
                <div class="row">
                    <v-card-title class="text-left">{{ $t('Brands.Name') }}<span class="red">*</span></v-card-title>
                </div>
                <div class="row">
                    <v-text-field v-model="BrandName" id="Title" name="Title" maxlength="30" hide-details
                        persistent-placeholder
                        :placeholder="$t('placeholder.enter', { itm: $t('Brands.PlaceHolderTags.Name') })"
                        variant="outlined" class="rounded-xl"></v-text-field>
                    <span class="warningHint" id="WarningMsgReference">{{ msg.BrandName }}</span>
                </div>
            </div>

            <div class="col-4 justify-content-start">
                <div class="row">
                    <v-card-title class="text-left">{{ $t('Brands.Supplier') }}<span class="red">*</span></v-card-title>
                </div>
                <div class="row">
                    <v-autocomplete :style="MySupplier ? 'pointer-events: none;' : ''" v-model="supplierId"
                        @update:model-value="handleSupplierSelect" :items="suppliers" item-title="name"
                        item-value="supplierId" persistent-placeholder variant="outlined" :placeholder="$t('placeholder.select', {
                            itm: $t('Brands.Supplier'),
                        })
                            " hide-details>
                        <template v-slot:item="{ props, item, index }">
                            <v-list-item v-bind="props" variant="text" :id="index" :name="item.brandName">
                                {{ item.brandName }}
                            </v-list-item>
                        </template>
                    </v-autocomplete>
                    <span class="warningHint" id="WarningMsgCompany">{{ msg.Supplier }}</span>
                </div>
            </div>


            <div class="col-4 justify-content-start">
                <div class="row">
                    <v-card-title class="text-left">{{ $t("Brands.Category")
                    }}<span class="red">*</span></v-card-title>
                </div>
                <div class="row">
                    <autocompleteGrouped v-model="IdCategories" :items="flattenedCategories" :placeholder="$t('placeholder.select', {
                        itm: $t('Brands.Category'),
                    })
                        " />
                    <span class="warningHint" id="WarningMsgCompany">{{ msg.categories }}</span>
                </div>
            </div>
        </div>
        <!-- -->
        <div class="row ma-4">
            <div class="row">
                <v-card-title class="text-left">{{ $t('Brands.Description') }}</v-card-title>
            </div>
            <div class="row">
                <v-textarea id="Comment" v-model="Description" variant="outlined"
                    :placeholder="$t('placeholder.enter', { itm: $t('Brands.PlaceHolderTags.Description') })"
                    hide-details maxlength="500" class="py-3" rows='5' no-resize></v-textarea>
            </div>

        </div>
        <div class="row ma-4" v-if="item?.logo != 'null'">
            <div class="row">
                <v-card-title class="text-left">{{ $t('configuration.company.logo') }}</v-card-title>
            </div>
            <div class="row">
                <uploadLogo :API="2" @addLogo="setLogo" :namelogo="logoImage" />
            </div>
        </div>
    </v-card>

</template>
<script>
import genericBtnComponent from "@/genericComponent/genericBtnComponent.vue"
import uploadLogo from '@/genericComponent/uploadLogo.vue'
import autocompleteGrouped from "@/genericComponent/autocompleteGrouped.vue";
import {
    getAllCategories, isSupplier,
    idSupplier, getAllSuppliersForProducts, CreateBrand
} from "@/api/index";
export default {
    components: {
        genericBtnComponent, uploadLogo, autocompleteGrouped
    },
    mounted() {
        document.title = window.VUE_APP_NAME + ' - ' + this.$t('Document.Title.Brands');
        this.fetchCategoriesAndSuppliers();
    },
    data: () => ({
        IdCategories: [],
        logoImage: null,
        item: null,
        categories: [],
        MySupplier: null,
        Title: null,
        supplierId: null,
        selectedSupplierName: null,
        SupplierSearch: null,
        suppliers: [],
        msg: [],
        loader: false,
        Description: null,
        BrandName: null

    }),
    methods: {
        handleSupplierSelect(value) {
            const selectedSupplier = this.suppliers.find(supplier => supplier.supplierId === value)
            if (selectedSupplier) {
                this.selectedSupplierName = selectedSupplier.name
            }
        },
        setLogo(value) {
            this.logoImage = value;

        },
        ActiveWarningSnackBar() {
            this.getParent('MainLayout').ActiveWarningSnackBar();
        },
        ActiveSavedSnackBar() {
            this.getParent('MainLayout').ActiveSavedSnackBar();
        },
        getParent(name) {
            let p = this.$parent;
            while (typeof p !== 'undefined') {
                if (p.$options.name == name) {
                    return p;
                } else {
                    p = p.$parent;
                }
            }
            return false;
        },
        async fetchCategoriesAndSuppliers() {
            try {
                const [categoriesResponse, suppliersResponse] = await Promise.all([
                    getAllCategories(),
                    getAllSuppliersForProducts(),
                ]);
                this.categories = categoriesResponse.data;
                this.suppliers = suppliersResponse.data;

                if (isSupplier()) {
                    this.MySupplier = idSupplier();
                    this.supplierId = this.MySupplier;
                    this.selectedSupplierName = this.suppliers.find(s => s.supplierId == this.supplierId).name
                }
            } catch (error) {
                console.error("Error fetching categories or suppliers:", error);
            }
        },
        navigateToList() {
            this.$router.push({ path: "/BrandsMenu" });
        },
        async validateBrand() {
            this.loader = true
            if (!this.supplierId || this.supplierId.length == 0) {
                this.msg["Supplier"] = this.$t('warningInput.isrequired', { itm: this.$t('Brands.Supplier') });
            } else {
                this.msg["Supplier"] = "";
            }

            if (!this.BrandName || this.BrandName.length == 0) {
                this.msg["BrandName"] = this.$t('warningInput.isrequired', { itm: this.$t('Brands.Name') });
            } else {
                this.msg["BrandName"] = "";
            }
            if (!this.IdCategories || this.IdCategories.length == 0) {
                this.msg["categories"] = this.$t('warningInput.isrequired', { itm: this.$t('Brands.Category') });
            } else {
                this.msg["categories"] = "";
            }
            if (this.msg["Supplier"] == "" && this.msg["BrandName"] == "" && this.msg["categories"] == "") {
                let logoBlob = "";
                if (this.logoImage) {
                    const fileStream = await this.logoImage.arrayBuffer();
                    logoBlob = new Blob([fileStream], { type: this.logoImage.type });
                }
                CreateBrand(this.BrandName, this.Description, logoBlob, [...this.IdCategories], this.supplierId, this.selectedSupplierName).then(() => {
                    this.navigateToList();
                    this.ActiveSavedSnackBar()
                }).catch(() => this.ActiveWarningSnackBar())

            }
            this.loader = false


        }
    },
    computed: {
        flattenedCategories() {
            const flatten = (cats, parentId = null, level = 0) => {
                return cats.reduce((acc, category) => {
                    if (category.parent_category_id === parentId) {
                        const flatCategory = {
                            ...category,
                            name: "  ".repeat(level) + category.name,
                        };
                        acc.push(flatCategory);
                        acc.push(...flatten(cats, category.categoryId, level + 1));
                    }
                    return acc;
                }, []);
            };
            return flatten(this.categories);
        },


    }

};
</script>
<style scoped>
.title {
    margin-top: auto;
    font-size: 18px;
    line-height: 25.5px;
    font-weight: 700;
    font-family: inter;
}

.v-card-title {
    font-family: inter;
    font-style: normal;
    font-weight: 600;
    font-size: 16px;
    color: #5b6d8e;
    margin-left: 12px;
    padding-left: 0;
    margin-top: 0;
    padding-top: 0;
}



.v-autocomplete {
    margin-left: 12px !important;
}

.border-bottom {
    border-bottom: 1px solid #ddd;
}

.border-right {
    border: 1px solid #ddd;
    text-align: center;
    border-style: dotted;
    padding: 2px 4px;
}

.totals {
    margin-top: 20px;
    /* font-weight: bold; */
}

.rounded-table {
    border-radius: 10px;
}

.totals p {
    margin: 5px 0;
}

.align-right {
    padding-right: 85px;
    text-align: right;
    position: relative;
}

.align-devise {
    float: right;
    margin-left: -16px;
}

.custom-divider {
    border-top: 1px solid;
    border-color: currentColor;
}

.add-line {
    display: inline-block;
    color: blue;
    cursor: pointer;
    margin-top: 10px;
}

.add-icon {
    color: #0000FF;
}

.customWarningHint {
    color: #F25C5C;
    padding: 12px 0px 12px 12px;
    font-family: 'Inter';
    font-style: normal;
    font-weight: 500;
    font-size: 14px;
    line-height: 0px;
    display: block;
    text-align: left;
    text-wrap: nowrap;
}
</style>